import { ToastContainer } from 'react-toastify';
import { loadToastifyCss } from '../utils/loadToastifyCss';

// Dispara o fetch do CSS assim que o bundle principal avalia este módulo,
// ainda fora do CSS bloqueante do HTML e antes dos useEffect de toast.
loadToastifyCss();

/**
 * ToastContainer com CSS adiado: o ReactToastify.css sai do CSS bloqueante
 * da home. O container permanece montado para não perder toasts.
 */
export default function DeferredToastContainer(props) {
  return <ToastContainer {...props} />;
}
